const OpportunityStatusConstants = {
    DRAFT: 0,
    INPROGRESS: 1,
    NOGO: 2,
    CONVERTEDTOPROPOSAL: 3
}

export default OpportunityStatusConstants